<template>
  <div class="fade-in">
    <div class="columns is-multiline">
      <div class="column is-full">
        <h1 class="title is-pulled-left">Interview Templates</h1>
        <div class="is-pulled-right text-right">
          <router-link
            :to="{ name: 'interview-create' }"
            class="button is-primary is-small"
          >
            <i class="fa fa-plus"></i> New Interview
          </router-link>
        </div>
        <div class="is-clearfix"></div>
      </div>
    </div>

    <table class="table is-striped is-responsive">
      <thead>
        <tr>
          <th>Name</th>
          <th>Interview Type</th>
          <th>Tags</th>
          <th>Last Updated</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="loading">
          <td colspan="5" class="has-text-centered">
            <i class="fa fa-refresh fa-spin"></i>
          </td>
        </tr>
        <tr v-if="!loading" v-for="interview in interviews">
          <td>{{ interview.attributes.name }}</td>
          <td>{{ interview.attributes.kind }}</td>
          <td>
            <span
              class="multiselect__tag"
              v-for="tag in interview.attributes.tagList"
              >{{ tag }}</span
            >
          </td>
          <td>{{ interview.attributes.updatedAt | date }}</td>
          <td>
            <router-link
              :to="{ name: 'interview-edit-id', params: { id: interview.id } }"
              title="Edit questions"
              ><i class="fa fa-file-text-o"></i
            ></router-link>
            <a
              :href="previewUrl(interview)"
              target="_blank"
              class="ml1"
              title="Preview"
              ><i class="fa fa-eye"></i
            ></a>
            <router-link
              :to="{
                name: 'interview-edit-details',
                params: { id: interview.id }
              }"
              class="ml1"
              title="Edit name/tags"
              ><i class="fa fa-pencil"></i
            ></router-link>
            <a
              v-if="$can('interview:delete|interview:manage')"
              href="#"
              v-on:click.prevent="interviewDelete(interview)"
              class="ml1"
              title="Delete"
              ><i class="fa fa-times"></i
            ></a>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="!loading">
        <tr>
          <td colspan="5">
            <pager
              :current="currentPage"
              :total="pageCount"
              :onClick="getInterviews"
            />
          </td>
        </tr>
      </tfoot>
    </table>
    <div class="is-clearfix"></div>

    <alert ref="alert" title="Confirm Delete" :onConfirm="onConfirm"
      >Are you sure you want to delete this interview?</alert
    >
    <vue-toastr ref="toastr"></vue-toastr>
  </div>
</template>

<script>
import InterviewsService from "@/services/InterviewsService";
import alert from "@/components/alert";
import pager from "../practice/Pager";

export default {
  name: "interview-pool",

  components: {
    alert,
    pager
  },

  data() {
    return {
      loading: true,
      interviewId: null
    };
  },

  computed: {
    interviews() {
      return this.$store.getters["interview/pool"];
    },
    currentPage() {
      return this.$store.getters["interview/currentPage"];
    },
    pageCount() {
      return this.$store.getters["interview/pageCount"];
    }
  },

  methods: {
    interviewDelete(interview) {
      this.$refs.alert.open();
      this.interviewId = interview.id;
    },
    onConfirm() {
      InterviewsService.delete(this.interviewId)
        .then(() => {
          this.$refs.toastr.s("The interview has been deleted.");
          this.interviewId = null;
        })
        .catch(() => {
          this.$refs.toastr.e("There was an error deleting the interview.");
          this.interviewId = null;
        });
    },
    previewUrl(interview) {
      return InterviewsService.previewUrl(interview.id);
    },
    getInterviews(page = 1) {
      this.loading = true;
      InterviewsService.getPool(page).then(() => {
        this.loading = false;
      });
    }
  },

  mounted() {
    this.getInterviews();
  }
};
</script>

<style lang="scss"></style>
